import getListingQualityRuleDefinitions from '../../graphql/products/getListingQualityRuleDefinitions'
import getListingScore from '../../graphql/products/getListingScore'

import GraphQLRequest from 'Clutch/Utilities/GraphQLClient/GraphQLClient'

export async function fetchListingQualityScore(skuVariantNumber) {
  try {
    const res = await GraphQLRequest('/graphql/products', getListingScore, {
      skuVariantNumber,
    })
    return res?.listingScore ?? null
  } catch (err) {
    console.error('Failed to fetch listing quality score', err)
    return null
  }
}

let ruleDefinitionsPromise = null

export function fetchListingQualityRuleDefinitions() {
  if (!ruleDefinitionsPromise) {
    ruleDefinitionsPromise = GraphQLRequest('/graphql/products', getListingQualityRuleDefinitions, {})
      .then((res) => res?.listingQualityRuleDefinitions ?? [])
      .catch((err) => {
        console.error('Failed to fetch listing quality rule definitions', err)
        // Clear the memo so a transient failure does not leave every rule unnamed for the session
        ruleDefinitionsPromise = null
        return []
      })
  }

  return ruleDefinitionsPromise
}
